<input
  class="text-input"
  type="text"
  autocomplete="off"
  [class.review-input-error-border]="error"
  [maskito]="dateMask"
  [attr.id]="controlId"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="onInput($event.target.value)" />
